import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";
import { useAdminLoginMutation } from "../../features/auth/authApi";

export default function AdminLogin() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [adminLogin, { data, isLoading, isSuccess, error: responseError }] =
    useAdminLoginMutation();

  const handleLogin = async (e) => {
    e.preventDefault();
    adminLogin({
      email: emailRef?.current?.value,
      password: passwordRef?.current?.value,
    }).then((res) => {
      if (res?.data?.user.role === "student") {
        setError("Students cannot login from here!");
      }
    });
  };

  useEffect(() => {
    if (isSuccess && data?.user && responseError?.data === "") {
      //login success redirect to dashboard
      navigate("/admin/dashboard");
    }
    if (responseError?.data) {
      setError(responseError.data);
    }
    document.title = "Admin login";
  }, [responseError, setError, isSuccess, data, navigate]);
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" alt="" src={logo} />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Sign in to Admin Account
          </h2>
        </div>
        <form className="mt-8 space-y-2" onSubmit={handleLogin}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                ref={emailRef}
                onChange={() => setError("")}
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="login-input rounded-t-md"
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                ref={passwordRef}
                id="password"
                onChange={() => setError("")}
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="login-input rounded-b-md"
                placeholder="Password"
              />
            </div>
          </div>
          <div className="flex items-center justify-end">
            <div className="text-sm flex justify-between w-full">
              <Link
                to="/"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Login as student
              </Link>
              <Link
                to="/ForgotPassword"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Forgot your password?
              </Link>
            </div>
          </div>
          <div>
            <button
              disabled={isLoading}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Sign in
            </button>
          </div>
          {error !== "" && <Error message={error} />}
        </form>
      </div>
    </section>
  );
}
